import { getBackendUrl } from "@Utils";
import axiosWrapper from "../../services/axiosWrapper";
import { ResponsiveContainer, BarChart, Bar, Cell, XAxis, YAxis, Label, Tooltip } from "recharts";
import { useContext, useEffect, useState } from "react";
import NoPortalDataIllustration from "./NoPortalData";
import { ThemeContext } from "../../ProviderApp";
import { THEME_LIGHT } from "../../App.constant";
import css from "./index.module.css";
import { modulesNameSynonymMapper } from "@Services/constants";
import { useTranslation } from "react-i18next";

function ProjectUsersTile({ filterData }) {
  const [barData, setBarData] = useState(null);
  const [totalBarData, setTotalBarData] = useState(null);
  const themeContext = useContext(ThemeContext);
  const { t } = useTranslation();
  const init = async () => {
    const params = {
      take: 5,
      skip: filterData.ProjectUsersTile.skip,
    };

    const response = await axiosWrapper.post(`${getBackendUrl()}/portal/projectGraph`, params);
    const val = response.data?.data;
    setTotalBarData((state) => {
      if (state) {
        return [...state, ...val];
      }
      return val;
    });
  };

  useEffect(() => {
    init();
  }, [filterData.ProjectUsersTile.skip]);

  useEffect(() => {
    if (Array.isArray(totalBarData)) {
      setBarData(
        totalBarData.slice(
          filterData.ProjectUsersTile.skip,
          filterData.ProjectUsersTile.skip + filterData.ProjectUsersTile.take,
        ),
      );
    }
  }, [totalBarData]);

  const COLORS = ["#1080D6", "#38BA84", "#FECD04", "#5BB8FF", "#FF6D6F", "#FF5B1B", "#5B5496", "#DD8F49"];

  function CustomTooltip({ active, payload }) {
    if (active && payload && payload.length) {
      const { name, uv } = payload[0].payload;
      return <div className={css.pieTooltip}>{`${name} - ${uv} Users`}</div>;
    }
    return null;
  }

  return barData ? (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={barData}
        margin={{
          top: 30,
          right: 15,
          bottom: 30,
          left: 20,
        }}
      >
        <XAxis
          dataKey="name"
          stroke="#c6d0df"
          label={
            <Label
              value={window.location.host.includes("dpmsportal") ? `${modulesNameSynonymMapper.project}` : "Project"}
              position="bottom"
              offset={10}
              fill={themeContext.themeType === THEME_LIGHT ? "#192048" : "#f2f0f9"}
              fontSize={15}
              fontWeight="bold"
            />
          }
          tickLine={false}
          tick={themeContext.themeType == THEME_LIGHT ? { fill: "#192048" } : { fill: "#f2f0f9" }}
          dy={10}
        />
        <YAxis
          stroke="#c6d0df"
          label={
            <Label
              value="Users"
              angle={-90}
              position="left"
              offset={10}
              fill={themeContext.themeType === THEME_LIGHT ? "#192048" : "#f2f0f9"}
              fontSize={15}
              fontWeight="bold"
            />
          }
          tickLine={false}
          tick={themeContext.themeType == THEME_LIGHT ? { fill: "#192048" } : { fill: "#f2f0f9" }}
          dx={-10}
        />
        <Tooltip content={<CustomTooltip />} cursor={false} />
        <Bar dataKey="uv" stackId="a" barSize={30}>
          {barData.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={COLORS[index % COLORS.length]}
              style={{
                transition: "all 0.1s ease",
                cursor: "pointer",
              }}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  ) : (
    <NoPortalDataIllustration name={t("Projects")} />
  );
}

export default ProjectUsersTile;
